module.exports = __webpack_public_path__ + "static/img/img-4.53b3848.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4.jpg
// module id = 1+iq
// module chunks = 0